"use client";

import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const UploadButton = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: transparent;
  flex-shrink: 0;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  span {
    font-size: 14px;
    color: var(--textLight);
  }
`;

export const ImageList = styled.ul`
  display: flex;
  overflow-x: auto;
  gap: 10px;
  padding: 0;
  margin: 0;
  list-style: none;
  scroll-behavior: smooth;
`;

export const ImagePreview = styled.li`
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

export const Close = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  background: var(--red);
  border: none;
  color: white;
  border-radius: 50%;
  padding: 2px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;
